import React from 'react';
import clsx from 'clsx';

import Typography from '@material-ui/core/Typography';

import Title from '../../components/Title/Title';

import useStyles from './Style';

const Participantes = ({ edicao }) => {
    const classes = useStyles();
    return (
        <>
            <Title id="anchor-02" className={classes.title}>
                2. DOS PARTICIPANTES
            </Title>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>2.1</span> 
                Estão aptos a participar da {edicao}ª Olimpíada de Professores da OBMEP Mirim, professores que ministram aulas no <span className={clsx(classes.bolder, classes.underline)}>Ensino Fundamental I</span>, 
                com matrícula ativa em <span className={clsx(classes.bolder, classes.underline)}>escolas públicas (municipais, estaduais e federais)</span> ou <span className={clsx(classes.bolder, classes.underline)}>privadas</span> localizadas no território brasileiro.
            </Typography>
        </>
    )
}

export default Participantes;